module.exports = __webpack_public_path__ + "static/media/logo_inex_branco.96c803c7.svg";